import { useState, useEffect, useContext } from 'react'
import styles from './styles.module.css'
import Table from '../../../components/Table'
import { Select } from '../../../components/ModalInputs'
import { StaffRosterContext } from '../../../utils/context'
import { useDispatch } from 'react-redux'
import { getPersonEvents } from '../../../actions/personnel/personnel'

export default function Events() {
  const dispatch = useDispatch()
  const { personTabData, mid, addMode } = useContext(StaffRosterContext)

  const currentYear = new Date().getFullYear()
  const [selectedYear, setSelectedYear] = useState(`${currentYear}-${currentYear + 1}`)
  const [rows, setRows] = useState([])
  const [selectedRow, setSelectedRow] = useState(null)

  useEffect(() => {
    if (personTabData?.event) {
      setRows(personTabData.event)
    }
  }, [personTabData])

  // При смене года загружаем данные
  const handleYearChange = (e) => {
    const year = e.target.value
    setSelectedYear(year)
    if (mid && !addMode) {
      dispatch(getPersonEvents(mid, year))
    }
  }

  const years = []
  for (let i = currentYear - 5; i <= currentYear + 1; i++) {
    years.push(`${i}-${i + 1}`)
  }

  const handleRowSelect = (id) => {
    setSelectedRow(selectedRow === id ? null : id)
  }

  return (
    <div className={styles.tabWrapper}>
      {/* Форма */}
      <div className={styles.qualificationForm}>
        <div className={styles.inputsRow}>
          <Select
            label="Учебный год"
            value={selectedYear}
            onChange={handleYearChange}
          >
            {years.map(year => (
              <option key={year} value={year}>{year}</option>
            ))}
          </Select>
        </div>
      </div>

      {/* Таблица */}
      <div className={styles.qualificationTableSection}>
        <Table>
          <thead>
            <tr>
              <th>Дата</th>
              <th>Название</th>
              <th>Участвуют</th>
            </tr>
          </thead>
          <tbody>
            {rows.length > 0 ? (
              rows.map(row => (
                <tr
                  key={row.id}
                  onClick={() => handleRowSelect(row.id)}
                  className={selectedRow === row.id ? styles.selectedRow : ''}
                >
                  <td>{new Date(row.date).toLocaleDateString('ru-RU')}</td>
                  <td>{row.name}</td>
                  <td>{row.participants}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className={styles.emptyTable}>
                  Нет данных о мероприятиях
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  )
}
